// extracted by mini-css-extract-plugin
module.exports = {"container":"_rue6TUkxGrV5nIpZIwUg","body":"_3ZaN5ZMMK2100xhZplcQfi","content":"_1fVxphxpWMTuw-e2M_0Dgv","footer":"_1sLSxC6TSXsbwIUn6C2iK5"};